/* eslint-disable max-len */
import React from 'react';

interface RedoAltProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Save: React.FC<RedoAltProps> = ({ color, ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.75991 2.125H5.46591C4.57984 2.125 3.73007 2.47699 3.10353 3.10353C2.47699 3.73007 2.125 4.57984 2.125 5.46591V14.8462C2.125 15.6495 2.4441 16.4199 3.01211 16.9879C3.58011 17.5559 4.35049 17.875 5.15377 17.875M5.75991 2.125V4.456C5.75991 4.96232 5.96104 5.44791 6.31907 5.80593C6.67709 6.16396 7.16268 6.36509 7.669 6.36509H9.90836C10.4147 6.36509 10.9003 6.16396 11.2583 5.80593C11.6163 5.44791 11.8175 4.96232 11.8175 4.456V2.125M5.75991 2.125H11.8175M5.15377 17.875V12.8636C5.15377 12.1042 5.45548 11.3758 5.99251 10.8387C6.52955 10.3017 7.25793 10 8.01741 10H11.9826C12.7421 10 13.4705 10.3017 14.0075 10.8387C14.5445 11.3758 14.8462 12.1042 14.8462 12.8636V17.875M5.15377 17.875H14.8462M11.8175 2.125H11.8423C12.2185 2.12495 12.591 2.19903 12.9385 2.343C13.2861 2.48696 13.6019 2.698 13.8678 2.96405L16.8966 5.99282C17.2068 6.30307 17.4529 6.6714 17.6208 7.07676C17.7886 7.48212 17.875 7.91657 17.875 8.35532V14.8462C17.875 15.6495 17.5559 16.4199 16.9879 16.9879C16.4199 17.5559 15.6495 17.875 14.8462 17.875"
      stroke={props?.style?.color || color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Save;
